import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.js";

import "./styles/game.css";
import "./styles/game-screens.css";
import "./styles/dashboard.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
